import { Temporal } from "temporal-polyfill";
import {
  ProviderOfferFilter,
  type ProviderOffer,
} from "../components/provider-imports/provider-import-types";
import { filterProviderOffers } from "./provider-import-actions";

export function providerUpdateInstant(
  value: string | null | undefined,
): Temporal.Instant | null {
  if (!value) {
    return null;
  }
  try {
    return Temporal.Instant.from(value);
  } catch {
    return null;
  }
}

export function formatProviderUpdateDate(
  value: string | null | undefined,
): string | null {
  return (
    providerUpdateInstant(value)?.toLocaleString(undefined, {
      dateStyle: "medium",
    }) ?? null
  );
}

export function latestProviderUpdateAt(offers: ProviderOffer[]): string | null {
  let latest: Temporal.Instant | null = null;
  const available = filterProviderOffers({
    offers,
    filter: ProviderOfferFilter.Available,
  });
  for (const offer of available) {
    const updatedAt = providerUpdateInstant(offer.sourceUpdatedAt);
    if (
      updatedAt &&
      (!latest || Temporal.Instant.compare(updatedAt, latest) > 0)
    ) {
      latest = updatedAt;
    }
  }
  return latest?.toString() ?? null;
}
